import { render, staticRenderFns } from "./veStuSemesterEdit.vue?vue&type=template&id=6aed8b72&scoped=true"
import script from "./veStuSemesterEdit.vue?vue&type=script&lang=js"
export * from "./veStuSemesterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed8b72",
  null
  
)

export default component.exports